export default function movesToTheFirstPositionOfAnArrayByCondition(list) {
  list.forEach((item, i) => {
    if (item.action === false) {
      list.splice(i, 1);
      list.unshift(item);
    }
  });
  return list;
}
